import { BreadNormalCss } from '@/styles/typography';
import styled from 'styled-components';

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 30px 0;
`;

const Wrapper = styled.div<{ $wrap?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${({ $wrap }) => ($wrap && '20px') || '5px'};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.m}) {
    ${({ $wrap }) =>
      $wrap &&
      `
      gap: 20px;
      flex-flow: row wrap;
       div {
        flex: 1 0 calc(50% - 10px);
      }
      `}
  }
`;

const Label = styled.label`
  ${BreadNormalCss}

  a {
    color: ${({ theme }) => theme.colors.black};
  }
`;

const S = {
  Form,
  Wrapper,
  Label,
};

export default S;
